module.exports = __webpack_public_path__ + "media/images/logo_dong-82907f7649db8c37ca0e00bd3202f183.svg";